// extracted by mini-css-extract-plugin
export var searchHeader = "_44-0";
export var searchHeaderDark = "_44-1";